document.addEventListener('DOMContentLoaded', () => {
  let activeDrawerTrigger = null;

  const closeDrawers = (restoreFocus = true) => {
    document.querySelectorAll('[data-drawer]').forEach((drawer) => { drawer.hidden = true; });
    document.body.classList.remove('drawer-open');
    if (restoreFocus && activeDrawerTrigger) {
      activeDrawerTrigger.focus();
      activeDrawerTrigger = null;
    }
  };

  document.querySelectorAll('[data-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      const drawer = document.getElementById(trigger.dataset.drawerOpen);
      if (!drawer) return;
      event.preventDefault();
      closeDrawers(false);
      activeDrawerTrigger = trigger;
      drawer.hidden = false;
      document.body.classList.add('drawer-open');
      window.setTimeout(() => {
        const focusTarget = drawer.id === 'SearchDrawer'
          ? drawer.querySelector('input[type="search"]')
          : drawer.querySelector('.drawer-close');
        focusTarget?.focus();
      }, 30);
    });
  });

  document.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawers));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawers();
  });

  const predictiveInput = document.querySelector('[data-predictive-search-input]');
  const predictiveResults = document.querySelector('[data-predictive-search-results]');
  let predictiveController;
  let predictiveTimer;

  const clearPredictiveResults = () => {
    if (!predictiveResults || !predictiveInput) return;
    predictiveResults.replaceChildren();
    predictiveResults.hidden = true;
    predictiveInput.setAttribute('aria-expanded', 'false');
  };

  predictiveInput?.addEventListener('input', () => {
    window.clearTimeout(predictiveTimer);
    predictiveController?.abort();
    const query = predictiveInput.value.trim();
    if (query.length < 2) {
      clearPredictiveResults();
      return;
    }

    predictiveTimer = window.setTimeout(async () => {
      predictiveController = new AbortController();
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`;
        const response = await fetch(url, { signal: predictiveController.signal });
        if (!response.ok) throw new Error('Search request failed');
        const payload = await response.json();
        const products = payload.resources?.results?.products || [];
        clearPredictiveResults();
        if (!products.length) return;

        products.forEach((product) => {
          const link = document.createElement('a');
          link.href = product.url;
          link.setAttribute('role', 'option');

          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            image.loading = 'lazy';
            link.appendChild(image);
          }

          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = product.title;
          copy.appendChild(title);
          if (product.price) {
            const price = document.createElement('small');
            price.textContent = product.price;
            copy.appendChild(price);
          }
          link.appendChild(copy);
          predictiveResults.appendChild(link);
        });

        predictiveResults.hidden = false;
        predictiveInput.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') clearPredictiveResults();
      }
    }, 180);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-nav]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const submenuToggle = document.querySelector('[data-mobile-submenu-toggle]');
  const submenu = document.querySelector('[data-mobile-submenu]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const openLabel = menuToggle?.dataset.openLabel || 'Open menu';
  const closeLabel = menuToggle?.dataset.closeLabel || 'Close menu';
  let closeTimer;
  let submenuTimer;

  const closeMenu = (animate = true) => {
    if (!menu || !menuToggle) return;
    window.clearTimeout(closeTimer);
    menu.classList.remove('is-open');
    if (animate && !reducedMotion) {
      menu.classList.add('is-closing');
      closeTimer = window.setTimeout(() => menu.classList.remove('is-closing'), 430);
    } else {
      menu.classList.remove('is-closing');
    }
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.setAttribute('aria-label', openLabel);
    document.body.classList.remove('mobile-menu-open');
  };

  document.addEventListener('click', (event) => {
    const clickedMenuToggle = event.target.closest('[data-menu-toggle]');
    if (clickedMenuToggle && window.innerWidth <= 990) {
      event.preventDefault();
      event.stopPropagation();
      const opening = !menu?.classList.contains('is-open');
      if (opening) {
        window.clearTimeout(closeTimer);
        menu?.classList.remove('is-closing', 'is-exiting');
        menu?.classList.add('is-open');
        clickedMenuToggle.setAttribute('aria-expanded', 'true');
        clickedMenuToggle.setAttribute('aria-label', closeLabel);
        document.body.classList.add('mobile-menu-open');
      } else {
        closeMenu(true);
      }
      return;
    }

    const clickedSubmenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
    if (clickedSubmenuToggle && window.innerWidth <= 990) {
      event.preventDefault();
      event.stopPropagation();
      if (!submenu) return;
      window.clearTimeout(submenuTimer);
      const opening = clickedSubmenuToggle.getAttribute('aria-expanded') !== 'true';
      clickedSubmenuToggle.setAttribute('aria-expanded', String(opening));
      if (opening) {
        submenu.hidden = false;
        window.requestAnimationFrame(() => submenu.classList.add('is-open'));
      } else {
        submenu.classList.remove('is-open');
        submenuTimer = window.setTimeout(() => {
          if (!submenu.classList.contains('is-open')) submenu.hidden = true;
        }, reducedMotion ? 0 : 520);
      }
      return;
    }

    const link = event.target.closest('[data-mobile-nav] a');
    if (!link || window.innerWidth > 990 || event.defaultPrevented) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const destination = link.href;
    if (!destination) return;
    event.preventDefault();
    event.stopPropagation();
    link.classList.add('is-activating');
    menu?.classList.add('is-exiting');
    window.setTimeout(() => window.location.assign(destination), reducedMotion ? 0 : 190);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) {
      closeMenu(true);
      menuToggle?.focus();
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const firstHero = document.querySelector('#MainContent .hero, #MainContent .collection-hero--image');
  if (firstHero) header.classList.add('site-header--overlay');

  let updateQueued = false;
  const updateHeader = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 12);
    updateQueued = false;
  };

  updateHeader();
  window.addEventListener('scroll', () => {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(updateHeader);
  }, { passive: true });
});
